import { useFrontendTool } from "@copilotkit/react-core";
import type { ContactSupportProps } from "@memorang/ui/components/RedeemCopilot/ContactSupport";
import { events, useRedeemCopilotAnalytics } from "../analytics";
import { COPILOT_ACTIONS } from "../constants/actions";
import { getCopilotAction } from "../helpers";
import { COPILOT_CHOICES } from "../instructions";
import type { ActionExecutionResult } from "../renderers";

export const useRcContactSupport = ({
	supportDetails,
	handler: supportHandler,
}: {
	supportDetails: ContactSupportProps;
	handler: () => void;
}) => {
	const { trackRedeemCopilotEvent } = useRedeemCopilotAnalytics();

	useFrontendTool({
		...getCopilotAction(COPILOT_ACTIONS.CONTACT_SUPPORT),
		handler: (): ActionExecutionResult => {
			supportHandler();

			const type = "success";
			const message = "Created a support email template";

			trackRedeemCopilotEvent(events.contactSupportInitiated, {
				type,
				message,
				supportDetails,
			});

			return {
				type,
				message,
				result: supportDetails,
				instructions: COPILOT_CHOICES.CONTACT_SUPPORT,
			};
		},
	});
};
